<template>
	<router-link
		:to="to"
		class="block no-underline w-full"
		:aria-label="ariaLabel"
	>
		<div
			class="rounded-lg p-3 sm:p-3 h-auto sm:h-20 flex flex-col sm:flex-row sm:items-center justify-between bg-primary-dark text-white shadow-sm hover:shadow-lg transition-transform transform hover:-translate-y-0.5 cursor-pointer"
			:class="borderClass"
		>
			<div class="flex items-center gap-3 min-w-0">
				<div
					:class="[
						'w-9 h-9 sm:w-10 sm:h-10 flex-shrink-0 rounded-lg bg-white flex items-center justify-center shadow-md',
						iconClass,
					]"
				>
					<slot name="icon"></slot>
				</div>

				<div class="min-w-0">
					<div
						class="text-sm sm:text-sm font-medium text-white/90 whitespace-normal sm:truncate"
					>
						{{ title }}
					</div>
				</div>
			</div>

			<div class="text-right mt-3 sm:mt-0 sm:ml-4">
				<div class="text-xl sm:text-2xl font-extrabold leading-none">
					{{ count }}
				</div>
			</div>
		</div>
	</router-link>
</template>

<script>
export default {
	name: 'StatsCard',
	props: {
		title: { type: String, required: true },
		count: { type: [Number, String], default: 0 },
		to: { type: [Object, String], default: '#' },
		borderClass: { type: String, default: '' },
		iconClass: { type: String, default: '' },
		ariaLabel: { type: String, default: '' },
	},
};
</script>

<style scoped></style>
